import React, { createContext } from 'react';
import { useQuery } from '@apollo/client';
import Loading from '../components/Loading';
import PROFILE from '../queries/profile';
import TEAM_PROFILE from '../queries/team';
import ExternalCalendarWarning from '../components/ExternalCalendarWarning';

const DataContext = createContext({
  user: null, team: null,
});

export const DataProvider = ({ children }) => {
  const { loading: profileLoading, data: profileData, refetch: profileRefetch } = useQuery(PROFILE);
  const teamId = profileData?.me?.currentTeam?.id;
  const { loading: teamLoading, data: teamData, refetch: teamRefetch } = useQuery(TEAM_PROFILE, {
    skip: !teamId,
    variables: { id: teamId },
  });

  if (profileLoading || teamLoading) return <Loading />;

  const hasExternalCalendarError = profileData?.me?.externalAccounts?.some((account) => account.status === 'error') || false;

  return (
    <DataContext.Provider
      value={{
        user: profileData.me,
        profileRefetch,
        team: teamData?.team,
        teamRefetch,
      }}
    >
      {hasExternalCalendarError && <ExternalCalendarWarning />}
      {children}
    </DataContext.Provider>
  );
};

export default DataContext;
